'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/axios/lib/cancel/isCancel.js
// module id = 177
// module chunks = 0